<template>
  <a-card :bordered="false" :bodyStyle="{paddingTop:'0px'}"
          :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-row slot="title">
      <a-col :span="24" style="cursor: pointer;">
        <span @click="goBack">销售数据</span>>{{ cardName }}
      </a-col>
    </a-row>
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="激活人昵称" v-bind="searchItemLayout">
            <a-input v-model="queryParams.activeMemberNickName" allow-clear placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="激活人手机" v-bind="searchItemLayout">
            <a-input v-model="queryParams.activeMemberMobile" allow-clear placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="激活日期" v-bind="searchItemLayout">
            <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%"/>
          </a-form-item>
        </search-list>
      </search-header>
      <search-header :col="2">
        <search-list>
          <a-form-item>
            <a-button type="primary" @click="searchBtn">查询</a-button>
            <a-button @click="exportData">批量导出</a-button>
            <a-button @click="handleLook">查看已生成报表</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <custom-page-table
      ref="table"
      rowKey="id"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <div slot="actionName" slot-scope="data">
        {{ data.text }}<br/>{{ data.record.activeMemberMobile }}
      </div>
      <span class="price-class" slot="moneySlots1" slot-scope="data">￥{{ data.text }}</span>
      <span class="price-class" slot="moneySlots2" slot-scope="data">￥{{ data.text }}</span>
      <div slot="action" slot-scope="data">
        <a @click="onOpenDeatil(data.record)">交易明细</a>
      </div>
    </custom-page-table>
    <selected-product-dialog
      :show="showSelectedDialog"
      title="交易记录"
      ref="pageList"
      :query-params="selectedQueryParams"
      :enableSearch="false"
      :requestPromise="loadPircePromise"
      row-key="logId"
      @close="showSelectedDialog=false"
      :columns="getPriceColumns()"
    >
      <span class="price-class" slot="priceSlots" slot-scope="data">
        <span>{{ data.text }}</span>
      </span>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'
import moment from 'moment'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'EntityCardList',
  mixins: [searchForm],
  components: {
    SelectedProductDialog
  },
  data() {
    return {
      moment,
      selectedDate: undefined,
      showSelectedDialog: false,
      visible: false,
      cardName: this.$route.query.cardName,
      merchantId: this.$store.getters.userInfo.merchantId,
      queryParams: {
        activeEndDay: '',
        activeMemberNickName: '',
        activeMemberMobile: '',
        activeStartDay: '',
        membershipCardId: ''
      },
      selectedQueryParams: {
        cardId: ''
      },
      loadPromise: params => this.getListPromise(params),
      loadPircePromise: params => this.getPriceListPromise(params),
      columns: [
        {
          title: '卡号',
          dataIndex: 'id'
        },
        {
          title: '卡密',
          dataIndex: 'cardPassword'
        },
        {
          title: '激活时间',
          dataIndex: 'activeTime'
        },
        {
          title: '激活人',
          dataIndex: 'activeMemberNickName',
          scopedSlots: { customRender: 'actionName' }
          // scopedSlots: { customRender: 'nameSlots' },
        },
        {
          title: '金额(元)',
          dataIndex: 'denomination',
          scopedSlots: { customRender: 'moneySlots1' }
        },
        {
          title: '剩余金额(元)',
          dataIndex: 'ableMoney',
          scopedSlots: { customRender: 'moneySlots2' }
        },
        {
          title: '有效期',
          dataIndex: 'validityValue'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      selectedDateTime: ''
    }
  },
  mounted() {
  },
  activated() {
    this.queryParams.membershipCardId = this.$route.query.cardId
    this.cardName = this.$route.query.cardName
    this.$refs.table.refresh(true)
  },
  deactivated() {
    this.queryParams = {
      activeEndDay: '',
      activeMemberNickName: '',
      activeMemberMobile: '',
      activeStartDay: '',
      membershipCardId: ''
    }
  },
  watch: {
    // 'selectedQueryParams.cardId': function(newVal, oldVal) {
    //   this.$nextTick(()=>{
    //     console.log(newVal,oldVal)
    //     if(oldVal&&oldVal!=""){
    //       this.$refs.pageList.refresh(true);
    //     }
    //   })
    // }
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      if (params.membershipCardId) {
        this.queryParams = params
        return this.getHttpServices().getUserService().post('member/v2/card/getEntitySaleData', params)
      } else {
        return new Promise((resolve, reject) => {
          const result = {
            pageSize: 10,
            pageNo: 1,
            totalCount: 0,
            totalPage: 1,
            data: []
          }
          resolve(result)
        })
      }

    },
    //日期变更
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.activeStartDay = dateStrArr[0]//购买开始日期
      this.queryParams.activeEndDay = dateStrArr[1]//购买结束日期
    },
    searchBtn() {
      this.$refs.table.refresh(true)
    },
    onOpenDeatil(record) {
      this.getLogUtils().logWithTag('==getListPromise==', record)
      this.showSelectedDialog = true
      this.selectedQueryParams.cardId = record.id
      this.$nextTick(() => {
        this.$refs.pageList.refresh(true)
      })
    },
    // 订单导出
    exportData() {
      this.searchBtn()
      this.getLogUtils().logWithTag('==getListPromise==', this.queryParams)
      this.getHttpServices().getUserService().post('member/v2/card/entityCardExport', this.queryParams).then(res => {
        this.$message.success('批量导出成功，请去报表中心下载')
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 查看已生产报表
    handleLook() {
      this.$router.push({
        name: 'DownloadTable'
      })
    },
    //表格数据
    getPriceListPromise(params) {
      if (params.cardId) {
        return this.getHttpServices().getOrderService().post('order/membership/query/transaction/order', params)
      } else {
        return new Promise((resolve, reject) => {
          const result = {
            pageSize: 10,
            pageNo: 1,
            totalCount: 0,
            totalPage: 1,
            data: []
          }
          resolve(result)
        })
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    getPriceColumns() {
      return [
        {
          title: '类型',
          dataIndex: 'logOrderTypeStr'
        },
        {
          title: '时间',
          dataIndex: 'logTransactionTime'
        },
        {
          title: '金额',
          dataIndex: 'logOrderAmountStr',
          scopedSlots: { customRender: 'priceSlots' }
        },
        {
          title: '订单号',
          dataIndex: 'logOrderNo'
        },
        {
          title: '所属店铺',
          dataIndex: 'logShopName'
        }
      ]
    }

  }

}
</script>
<style scoped>
.ant-btn + .ant-btn {
  margin-left: 10px;
}

.price-class {
  color: #fea834;
}

.text-r {
  text-align: right;
}

.lh20 {
  line-height: 20px;
  margin-bottom: 15px;
}
</style>